var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    (_vm.member.Active__c &&
      !_vm.member.npsp__Deceased__c &&
      (!_vm.member.Household_Role__c || _vm.member.Household_Role__c === 'Main') &&
      this.taskId !== null) ||
    _vm.isLoading
  )?_c('div',{class:{
    'print-card-container': true,
    family: _vm.member.Household_Role__c === 'Main',
  }},[(!_vm.isLoading)?[(
        _vm.member.Active__c &&
        !_vm.member.npsp__Deceased__c &&
        (!_vm.member.Household_Role__c || _vm.member.Household_Role__c === 'Main') &&
        this.taskId !== null
      )?_c('v-btn',{attrs:{"small":"","depressed":"","color":"#b8e994"},on:{"click":_vm.print}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(" mdi-printer ")]),(_vm.member.Household_Role__c === 'Main')?_c('span',[_vm._v("Isprintaj obiteljske iskaznice")]):_c('span',[_vm._v("Isprintaj iskaznicu")])],1):_vm._e()]:_c('div',{staticClass:"print-loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#1358a3"}})],1),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticClass:"print-error",attrs:{"outlined":"","text":"","type":"error"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]),(_vm.test)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.test)}}):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }